module.exports = __webpack_public_path__ + "img/pay_trend.2d1a36c1.jpg";